/**
 * Plush testimonials slideshow — hero-style autoplay with a SEAMLESS infinite
 * loop. The card set is cloned once and appended; autoplay only ever moves
 * forward, and when it scrolls into the cloned set it instantly snaps back by one
 * set width. Because the clones are identical, the reset is invisible — so it
 * never does the ugly "rewind to the start" scroll. Dots, swipe, and
 * pause-on-interaction all work like the hero.
 */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.testiReady === '1') return;
    root.dataset.testiReady = '1';

    var track = root.querySelector('[data-testi-track]');
    if (!track) return;

    var originals = Array.prototype.slice.call(track.children).filter(function (el) {
      return el.nodeType === 1;
    });
    var count = originals.length;
    if (count < 2) return;

    // Clone the whole set once for the seamless loop.
    originals.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.clone = '1';
      track.appendChild(clone);
    });

    var all = Array.prototype.slice.call(track.children).filter(function (el) {
      return el.nodeType === 1;
    });
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-testi-dot]'));

    function step() {
      return all.length > 1 ? all[1].offsetLeft - all[0].offsetLeft : track.clientWidth;
    }
    function index() {
      var s = step();
      return s ? Math.round(track.scrollLeft / s) : 0;
    }
    function goTo(i, instant) {
      if (!all[i]) return;
      track.scrollTo({ left: all[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }
    function refreshDots() {
      var cur = ((index() % count) + count) % count;
      dots.forEach(function (dot, j) {
        dot.classList.toggle('is-active', j === cur);
      });
    }
    // If we've scrolled into the cloned set, jump back by one set (instant).
    function normalize() {
      var i = index();
      if (i >= count) {
        track.scrollTo({ left: all[i - count].offsetLeft, behavior: 'auto' });
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-testi-dot'), 10));
      });
    });

    var raf, settleTimer;
    track.addEventListener(
      'scroll',
      function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(refreshDots);
        clearTimeout(settleTimer);
        settleTimer = setTimeout(normalize, 130);
      },
      { passive: true }
    );

    var interval = parseInt(track.getAttribute('data-autoplay'), 10);
    if (interval > 0) {
      var timer = null;
      var play = function () {
        stop();
        timer = setInterval(function () {
          goTo(index() + 1);
        }, interval * 1000);
      };
      var stop = function () {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };
      root.addEventListener('pointerenter', stop);
      root.addEventListener('pointerdown', stop);
      root.addEventListener('pointerleave', play);
      track.addEventListener('touchstart', stop, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else play();
      });
      play();
    }

    refreshDots();
  }

  function boot() {
    document.querySelectorAll('[data-plush-testimonials]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
